import React from "react";
import useLangTranslation from "../../../customHooks/languageProvider";
import { useSelector } from "react-redux";

function CommonStatus({ status }) {
  const { getLangTranslation }  = useLangTranslation();
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
  if (status === 1)
    return (
      <p className="mb-0 text-small text-success">
        <span className={`badge rounded-pill d-inline-block badge-sm bg-success ${lang?.isRTL === 1 ? 'ms-1' : ' me-1'}`}></span>
        {getLangTranslation("CHILD_DASHBOARD_ACTIVE_NOW", "Active Now")}
      </p>
    );
  if (status === 0) { 
    return (
      <p className="text-secondary mb-0 text-small">
        <span  className={`badge rounded-pill d-inline-block badge-sm bg-gray-200 ${lang?.isRTL === 1 ? 'ms-1' : ' me-1'}`}></span>
        {getLangTranslation("CHILD_DEVICE_INACTIVE_NOW", "Inactive Now")}
      </p>
    );
  }

  return (
    <p className="mb-0 text-small text-gray">
      {/* <span className="badge rounded-pill d-inline-block badge-sm bg-gray me-1"></span> */}
      {getLangTranslation("STATUS_UNKNOWN", "Status unknown")}
    </p>
  );
}

export default CommonStatus;
